import { FC, useEffect } from 'react';
import V2FormInputNumber from '@/common/components/Form/V2FormInputNumber/V2FormInputNumber';
import { parseValueCatch } from '../config';

/**
 * @Description 销售额预测
 */
const SaleAmount: FC<{
  form: any;
  formItemData: any;
  required?: boolean;
}> = ({
  form,
  formItemData,
  required,
}) => {
  const label = formItemData.anotherName || formItemData.name || '';
  const restriction = formItemData.restriction ? JSON.parse(formItemData.restriction) : {};
  const placeholder = restriction.placeholder ? restriction.placeholder : `选择详细地址后自动获取`;

  useEffect(() => {
    const curVal = parseValueCatch(formItemData);

    form.setFieldsValue({
      [formItemData.identification]: curVal?.saleAmount,
    });
  }, [formItemData, formItemData.textValue]);

  return (
    <V2FormInputNumber
      label={label}
      name={formItemData.identification}
      placeholder={placeholder}
      required={required}
      disabled={true}
    />
  );
};

export default SaleAmount;
